<app-form-generator
    [formGeneratorInput]="childIntegrationFormGenInput"
></app-form-generator>
